import React, { useState, useRef, useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import ReactCodeInput from 'react-code-input'
import { connect, useSelector } from 'react-redux'
import {
  login,
  sendAccessCode,
} from 'application/actions/authenticationActions'
import { encodePhone, encodeEmail } from 'application/helpers'
import Message from '../../message'
import { useHistory } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './loginElements'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import { Icon as RemServIcon } from 'RemServ/icons'

const inputStyle = {
  MozAppearance: 'textfield',
  margin: '4px',
  width: '40px',
  height: '45px',
  fontSize: '1rem',
  lineHeight: '1.5',
  textAlign: 'center',
  border: '2px solid',
  transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
}

const EnterCodeForm = ({
  setCanEnterCode,
  opportunityId,
  option,
  dispatch,
  isAuthenticating,
  mobile,
  email,
  isRequestingAccessCode,
}) => {
  const recaptchaRef = useRef()
  const [accessCode, setAccessCode] = useState('')
  const history = useHistory()
  const handleChange = (value) => {
    setAccessCode(value)
  }
  var isAtSettlement = useSelector((state) => state.user.isAtSettlement)
  const getCaptchaToken = async () => {
    const token = await recaptchaRef.current.executeAsync()
    recaptchaRef.current.reset()
    return await token
  }

  const goBack = () => {
    setCanEnterCode(false)
  }

  const handleLogin = async () => {
    var token = await getCaptchaToken()

    dispatch(login(opportunityId, accessCode, history, token, isAtSettlement))
  }
  const pinInput = useRef()

  const resendCode = async () => {
    var token = await getCaptchaToken()
    dispatch(sendAccessCode(opportunityId, option, token))
    clearAccessCode()
  }

  const clearAccessCode = () => {
    for (let i = 0; i < 6; i++) {
      pinInput.current.state.input[i] = ''
      pinInput.current.textInput[i].value = ''
    }
    setAccessCode('')
  }
  const goBackText =
    global.config.brand === 'Maxxia' ? 'Change security method' : 'Go back'
  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        handleLogin()
      }
    }
    document.addEventListener('keydown', listener)
    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [accessCode])

  return (
    <Form className="px-5 d-flex flex-column align-items-center">
      <PrimaryButton
        variant="d-inline-flex"
        invertColor
        onClick={goBack}
        size="sm"
        className={global.config.brand === 'Maxxia' ? 'mb-4' : ''}
        extendInMob
        id="entercodeform.backbutton"
      >
        {global.config.brand === 'Maxxia' && (
          <MaxxiaIcon iconType="BackArrow" primary alt="" />
        )}
        {global.config.brand === 'RemServ' && (
          <>
            <RemServIcon iconType="BackArrow" primary alt="" />
          </>
        )}
        <span className="ml-1">{goBackText}</span>
      </PrimaryButton>

      <Message className="mt-3" resendCodeOption={option} resendCodeCallback={resendCode} />
      <E.enterCodeHeading>Enter your verification code</E.enterCodeHeading>

      <E.enterCodeBody>
        We just sent a verification code to{' '}
        {option === 'mobile' && <span id="entercodeform.mobile">{mobile}</span>}
        {option === 'email' && <span id="entercodeform.email">{email}</span>}
        <br />
        <p className={global.config.brand === 'Maxxia' ? 'mt-4' : ''}>
          Enter the code below
        </p>
      </E.enterCodeBody>

      <ReactCodeInput
        className="d-flex mb-4 otp-input"
        type="number"
        fields={6}
        value={accessCode}
        onChange={handleChange}
        inputStyle={inputStyle}
        ref={pinInput}
        id="entercodeform.inputfield"
      />

      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        id="entercodeform.recaptcha"
      />

      {isAuthenticating && (
        <PrimaryButton
          disabled={accessCode.length !== 6}
          className=" mt-2"
          extendInMob
          id="entercodeform.verifying"
        >
          <>
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Authenticating...
          </>
        </PrimaryButton>
      )}
      {!isAuthenticating && (
        <PrimaryButton
          disabled={accessCode.length !== 6}
          className="mb-3 mt-2"
          onClick={handleLogin}
          extendInMob
          id="entercodeform.verify"
        >
          Verify code
        </PrimaryButton>
      )}

      <E.body
        className="text-smaller"
        style={{ marginTop: global.config.brand == 'Maxxia' ? '24px' : '6px' }}
      >
        Didn't get it?{' '}
        <a className="link clickable" id="entercodeform.resending">
          {isRequestingAccessCode ? (
            <>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Resending...
            </>
          ) : (
            <E.ResendLink onClick={resendCode} id="entercodeform.resendlink">
              Resend
            </E.ResendLink>
          )}
        </a>{' '}
      </E.body>
    </Form>
  )
}

function mapStateToProps(state) {
  const { opportunityId } = state.opportunity
  const { isFetching: isAuthenticating } = state.authentication
  const { mobile } = state.user
  const { email } = state.user
  const isRequestingAccessCode =
    state.accessCode && state.accessCode.isFetching
      ? state.accessCode.isFetching
      : false
  return {
    opportunityId,
    isAuthenticating,
    mobile: encodePhone(mobile),
    email: encodeEmail(email),
    isRequestingAccessCode,
  }
}

export default connect(mapStateToProps)(EnterCodeForm)
